import * as THREE from "three";
import type { RegionRow } from "./types";

export function buildRegions(
  regions: RegionRow[],
  sampleHeight: (x: number, z: number) => number,
): THREE.Object3D {
  const root = new THREE.Group();
  root.name = "regions";
  const liftAbove = 0.4;
  // Ground-ring depth policy (matches building-render.ts targeting rings): a flat
  // ring conforms poorly to sloped terrain, so it z-fights / clips the hillside.
  // Draw it always-on-top instead (depthTest/Write off + high renderOrder) so it
  // reads cleanly on any slope rather than flickering through the ground.
  const ringMat = new THREE.MeshBasicMaterial({
    color: 0xffe066,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.55,
    depthWrite: false,
    depthTest: false,
  });

  for (const r of regions) {
    if (r.name.startsWith("Fish,")) continue; // many fish zones — too noisy
    if (r.shape === "circle") {
      const geom = new THREE.RingGeometry(Math.max(0, r.r - 0.4), r.r, 48);
      geom.rotateX(-Math.PI / 2);
      const mesh = new THREE.Mesh(geom, ringMat);
      const y = sampleHeight(r.cx, r.cy);
      mesh.position.set(r.cx, y + liftAbove, r.cy);
      mesh.renderOrder = 998;
      mesh.name = `region:${r.name}`;
      root.add(mesh);
    }
  }
  return root;
}
